import PropTypes from "prop-types";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";

function LPSpacing({ content }) {
  const spacingValue = useResponsiveWithHydrationFix(
    content?.spacingMobile,
    content?.spacingDesktop
  );

  return (
    content && (
      <div
        className={`id-${content?.contentful_id}`}
        style={{ marginBottom: `${spacingValue}px`, height: "0px" }}
      >
        &nbsp;
      </div>
    )
  );
}

LPSpacing.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string.isRequired,
    spacingMobile: PropTypes.number.isRequired,
    spacingDesktop: PropTypes.number.isRequired,
  }).isRequired,
};

export default withALErrorBoundary({
  name: "LPSpacing",
  priority: "P4",
})(LPSpacing);
